import React from "react";
import PropTypes from "prop-types";

import ChecklistItem from "./ChecklistItem";

const Checklist = ({
  list, checkmarkColor = "text-accent", classNames, parentClassName,
}) => {
  const listItems = list.map(item => (
    <ChecklistItem
      key={item}
      content={item}
      checkmarkColor={checkmarkColor}
      classNames={classNames}
    />
  ));
  return <ul className={`list-reset mx-auto ${parentClassName}`} data-type-mapping="services_and_benefits" >{listItems}</ul>;
};

Checklist.propTypes = {
  list: PropTypes.array.isRequired,
  checkmarkColor: PropTypes.string,
  classNames: PropTypes.array,
  parentClassName: PropTypes.string,
};

export default Checklist;
